import { useFormik } from 'formik'
import toast from 'react-hot-toast'
import { BsChevronLeft } from 'react-icons/bs'
import { Link } from 'react-router-dom'
import * as Yup from 'yup'
import { useForgotPasswordMutation } from '../../../features/auth/passwordSlice'

interface ISentViaEmail {
  setStep: React.Dispatch<React.SetStateAction<'email' | 'code' | 'password'>>
  setEmail: React.Dispatch<React.SetStateAction<string>>
}

export const SentViaEmail = ({ setStep, setEmail }: ISentViaEmail) => {
  const [forgotPassword, { isLoading, isError, error }] =
    useForgotPasswordMutation()

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().email('Invalid email').required('Email is required'),
    }),
    onSubmit: async (values) => {
      try {
        toast.loading('Sending...')
        await forgotPassword(values).unwrap()
        toast.dismiss()
        toast.success(`Code sent to ${values.email}`)
        setStep('code')
        setEmail(values.email)
      } catch (error: any) {
        console.log(error)
        toast.dismiss()
        toast.error(error?.data.message)
      }
    },
  })

  return (
    <div className='bg-white w-full max-w-[400px] rounded-md shadow-lg px-5 py-10'>
      <h3 className='text-2xl text-indigo-500 font-semibold text-center'>
        Gcbuying
      </h3>
      <h4 className='text-lg font-[500] text-slate-600 mt-8'>
        Forgot Password? 🔒
      </h4>
      <p className='text-sm text-slate-500 mt-1'>
        Enter your email and we'll send you instructions to reset your password
      </p>

      <form action='' className='mt-6' onSubmit={formik.handleSubmit}>
        <div className='flex flex-col gap-1'>
          <label htmlFor='email' className='text-xs text-slate-600'>
            Email
          </label>
          <input
            type='email'
            name='email'
            id='email'
            value={formik.values.email}
            onChange={formik.handleChange}
            placeholder='john@example.com'
            className='transition-all duration-200 px-4 py-2 rounded-md text-sm border border-slate-300 focus:outline-none focus:ring-1 focus:ring-indigo-500'
          />
          <p className='text-red-500 text-xs'>
            {formik.touched.email &&
              Boolean(formik.errors.email) &&
              formik.errors.email}
          </p>
        </div>

        <button
          type='submit'
          className='mt-4 transition-all duration-200 w-full py-2 text-sm rounded-md text-white font-semibold bg-indigo-500 hover:brightness-105'
        >
          Send reset link
        </button>

        <Link
          to='/login'
          className='text-sm text-indigo-500 flex items-center gap-1 mt-4'
        >
          <BsChevronLeft className='text-lg text-indigo-500' /> Back to login
        </Link>
      </form>
    </div>
  )
}
